<template>
    <div>
   <!-- Start -->
   <section class="relative md:py-24 py-16 bg-gray-50 dark:bg-slate-800" id="features">
            <div class="container lg mx-auto">
                <div class="grid grid-cols-1 pb-8 text-center">
                    <h3 class="mb-4 md:text-2xl text-xl font-medium">Nos services</h3>

                    <p class="text-slate-400 max-w-xl mx-auto">Des solutions de paie fiables et premium pour accompagner les TPE & PME.</p>
                </div><!--end grid-->

                <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-4 gap-[30px]">
                    <!-- Content -->
                    <div v-for="item in servicesData" :key="item" class="group relative lg:px-6 mt-4 transition duration-500 ease-in-out rounded-xl overflow-hidden text-center">
                        <div class="relative overflow-hidden text-transparent -m-3">
                            <i data-feather="hexagon" class="size-28 fill-violet-600/5 mx-auto rotate-[30deg]"></i>
                            <div class="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-violet-600 rounded-xl transition duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                                <i :class=item.icon></i>

                            </div>
                        </div>

                        <div class="mt-6">
                            <router-link to="/services"  class="text-lg h5 transition duration-500 ease-in-out hover:text-violet-600">{{item.title}}</router-link>
                            <p class="text-slate-400 transition duration-500 ease-in-out mt-3">{{item.desc}}</p>
                        </div>
                    </div>
                    <!-- Content -->

                
                </div><!--end grid-->
            </div><!--end container-->
        </section><!--end section-->
        <!-- End  -->
    </div>
</template>

<script>
 import feather from 'feather-icons'

    export default {
        name: "featuresVue",
        data() {
            return {
              servicesData: [
                {
                  id: 1,
                  icon: 'uil uil-file-alt',
                  title: 'Gestion complète de la paie',
                  desc: 'Élaboration mensuelle des bulletins, gestion des variables, primes et absences pour une paie fiable et conforme.'
                },
                {
                  id: 2,
                  icon: 'uil uil-file-check-alt',
                  title: 'Déclarations sociales & DSN',
                  desc: 'Préparation et transmission de toutes vos obligations sociales : DSN, URSSAF, retraite, prévoyance, etc.'
                },
                {
                  id: 3,
                  icon: 'uil uil-user-check',
                  title: 'Entrées & sorties des salariés',
                  desc: 'Gestion des embauches, DPAE, contrats, avenants, attestations et documents liés au départ des salariés.'
                },
                {
                  id: 4,
                  icon: 'uil uil-balance-scale',
                  title: 'Conseil paie & conformité sociale',
                  desc: 'Accompagnement sur vos obligations légales, convention collective et bonnes pratiques en gestion sociale.'
                },
                {
                  id: 5,
                  icon: 'uil uil-search-alt',
                  title: 'Audit & mise en conformité',
                  desc: 'Analyse complète de vos pratiques de paie et recommandations pour sécuriser votre conformité sociale.'
                },
                {
                  id: 6,
                  icon: 'uil uil-headphones',
                  title: 'Assistance mensuelle & support',
                  desc: 'Support réactif tout au long de l’année pour répondre à vos questions et faciliter votre gestion sociale.'
                },
              ]
            }
        },
        components:{

        },
        mounted() {
        feather.replace();
        }
    }
</script>

<style lang="scss" scoped>

</style>